import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  // Usamos la clave definida en environment o una por defecto si no existe
  private secretKey = environment.storageSecretKey || 'fallback-secret-key'; 
  public isNative = Capacitor.isNativePlatform();

  constructor() { }

  async set(key: string, value: any, remember: boolean = true): Promise<void> {
    const encryptedValue = this.encrypt(JSON.stringify(value));
    
    if (this.isNative) {
      await Preferences.set({
        key: key,
        value: encryptedValue
      });
    } else {
      if (remember) {
        localStorage.setItem(key, encryptedValue);
      } else {
        sessionStorage.setItem(key, encryptedValue);
      }
    }
  }

  async get(key: string): Promise<any> {
    let value: string | null = null;

    if (this.isNative) {
      const result = await Preferences.get({ key: key });
      value = result.value;
    } else {
      // Intentar primero en sessionStorage (sesión actual)
      value = sessionStorage.getItem(key);
      // Si no está, buscar en localStorage (sesión persistente)
      if (!value) {
        value = localStorage.getItem(key);
      }
    }

    if (!value) return null;

    try {
      const decrypted = this.decrypt(value);
      return JSON.parse(decrypted);
    } catch (e) {
      console.error('Error al desencriptar datos de sesión', e);
      return null;
    }
  }

  async remove(key: string): Promise<void> {
    if (this.isNative) {
      await Preferences.remove({ key: key });
    } else {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }
  }

  async clear(): Promise<void> {
    if (this.isNative) {
      await Preferences.clear();
    } else {
      localStorage.clear();
      sessionStorage.clear();
    }
  }

  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.secretKey).toString();
  }

  private decrypt(txtToDecrypt: string): string {
    return CryptoJS.AES.decrypt(txtToDecrypt, this.secretKey).toString(CryptoJS.enc.Utf8);
  }
}
